import { Order, Table, Waiter, Access, User, Content, Avatar, OrgCategory, Offer } from "@/types";
import { z } from "zod";
import { IndustryId } from "@/constants/industries";
import { Website } from "./website";
import { Quote } from "./quote";

export const InvitationSchema = z.object({
  id: z.string().nullable(),
  email: z.string().email(),
  role: z.enum(["admin", "waiter"]),
  status: z.enum(["pending", "accepted", "rejected"]).nullable(),
});

export type Invitation = z.infer<typeof InvitationSchema>;

export enum PaymentMethods {
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  BANK_TRANSFER = "BANK_TRANSFER",
}

export interface OrganizationSettings {
  services: {
    delivery: {
      isEnabled: boolean;
    };
  };
  orderManagement: string;
  includeTax: boolean;
  paymentMethods: PaymentMethods;
}

export interface Organization {
  id: string;
  alias: string;
  title: string;
  industry: IndustryId;
  slogan?: string;
  logo?: string;
  isotype?: string;
  header?: string;
  categories?: OrgCategory[];
  createdAt: number;
  createdBy: string;
  lastUpdatedAt: number;
  lastUpdatedBy: string;
  tables?: Table[];
  orders?: Order[];
  waiters?: Waiter[];
  paidOrders?: Order[];
  access: Record<User["uid"], Access & User>;
  invitations?: Invitation[];
  content?: Content[] | Offer[];
  avatars?: Avatar[];
  primaryColor?: string;
  secondaryColor?: string;
  website?: Website["id"] | null;
  websites?: Website[];
  quotes?: Quote[];
  images?: string[];
  email: string;
  address: string;
  phone: number;
  whatsapp: number;
  latitude?: number;
  longitude?: number;
  settings: OrganizationSettings;
  // Social media
  facebook?: string;
  x?: string;
  instagram?: string;
  tiktok?: string;
  // SEO
  domain?: string;
  googleDomainVerificationToken?: string;
  isDomainVerifiedByGoogle?: boolean;
}
